import api from "api/axios";

export const getOffers = (params) =>
  api.get("/offers", params);

export const getOfferById = (id) =>
  api.get(`/offers/${id}`);

// export const fetchOrganizerOffers = (id) =>
//   api.get(`/offers/company/${id}`);

export const fetchOrganizerOffers = async (id , params = {}) =>{
   const response =  await api.get(`/offers/company/${id}`,{
    params,
    signal: params.signal, // Pass AbortController signal if provided
  });
   return response.data;
}

export const createOffer = (payload) =>
  api.post("/offers/", payload);

export const updateOffer = (id, payload) =>
  api.put(`/offers/${id}`, payload);

export const deleteOffer = (id, payload) =>
  api.delete(`/offers/${id}`, { data: payload });
